export const LIMIT_KEYWORD_PER_DOC = 700;
